<div class="lum-c-ui-confirmation-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content class="mat-typography">
    <h4>{{ data.message }}</h4>

    <div
      *ngIf="data.input?.type"
      [ngSwitch]="data.input?.type"
      class="lum-c-ui-confirmation-dialog__form form-group"
      [ngClass]="{ 'has-error': errors.length > 0 }"
    >
      <ng-template ngSwitchCase="checkbox">
        <mat-checkbox
          class="lum-c-ui-confirmation-dialog__form-checkbox"
          [(ngModel)]="valueBoolean"
          (ngModelChange)="onInputChange($event)"
          >{{ data.input.label }}</mat-checkbox
        >
      </ng-template>

      <ng-template ngSwitchCase="text">
        <label class="d-block">
          <div class="lum-c-ui-confirmation-dialog__form-label lum-label">{{
            data.input.label
          }}</div>
          <input
            type="text"
            class="lum-c-ui-confirmation-dialog__form-control form-control"
            [placeholder]="data.input.placeholder ?? ''"
            [(ngModel)]="valueString"
            (ngModelChange)="onInputChange($event)"
            (focus)="onInputFocus($event)"
          />
        </label>
        <ng-container
          *ngIf="data.input.maxLength"
          [ngTemplateOutlet]="displayMaxLength"
        ></ng-container>
      </ng-template>

      <ng-template ngSwitchCase="textarea">
        <label class="d-block">
          <div class="lum-c-ui-confirmation-dialog__form-label lum-label">{{
            data.input.label
          }}</div>
          <textarea
            class="lum-c-ui-confirmation-dialog__form-control form-control"
            [placeholder]="data.input.placeholder ?? ''"
            [(ngModel)]="valueString"
            (ngModelChange)="onInputChange($event)"
            (focus)="onInputFocus($event)"
          ></textarea>
          <ng-container
            *ngIf="data.input.maxLength"
            [ngTemplateOutlet]="displayMaxLength"
          ></ng-container>
        </label>
      </ng-template>

      <div class="lum-c-ui-confirmation-dialog__form-errors">
        <p *ngFor="let error of errors">{{ error.message }}</p>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      mat-button
      class="lum-button lum-button--secondary lum-button--medium w-20 mx-1"
      (click)="onNoClick()"
    >
      No
    </button>
    <button
      mat-button
      class="lum-button lum-button lum-button--medium w-20"
      (click)="onYesClick()"
    >
      Yes
    </button>
  </mat-dialog-actions>
</div>

<ng-template #displayMaxLength>
  <div
    class="text-right text-nowrap"
    [ngClass]="{
      'text-muted': (valueString?.length ?? 0) <= data.input.maxLength,
      'text-red-600': (valueString?.length ?? 0) > data.input.maxLength,
    }"
  >
    {{ valueString?.length ?? 0 }} / {{ data.input.maxLength }}
  </div>
</ng-template>
